import { format } from "rut.js";
import { columns } from "../../../../dtos/columns";
import { numericFormatter } from "react-number-format";
import { RowConsultaOCM } from "../models/rowConsultaOCM";
import Conversiones from "../../../../utils/conversiones";
import { RowResultEnvioOCM } from "../models/rowResultEnvio";

interface IProps {
    control: any;
}

export function useColumnsResult({control} : IProps) {

    const COLUMNS_RESULT: columns<RowResultEnvioOCM>[] = [
        {
            name: 'N° Operación',
            selector: (row: RowResultEnvioOCM) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            alling: 'left',
            export: true,
        },       
        {
            name: 'Monto',
            selector: (row: RowResultEnvioOCM) => numericFormatter((Math.round(row.monto * 100)/100).toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "CLP " }),
            sortable: true,
            sortField: 'monto',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: "Fecha cobro",
            selector: (row: RowResultEnvioOCM) => Conversiones.fechaConHoraFormat(row.fechaCobro.toString()),
            sortable: true,
            sortField: 'fechaCobro',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: "Fecha pago",
            selector: (row: RowResultEnvioOCM) => Conversiones.fechaConHoraFormat((row.fechaPago ?? "").toString()),
            sortable: true,
            sortField: 'fechaPago',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'RUT cliente',
            selector: (row: RowResultEnvioOCM) => format(row.rutCliente!),
            sortable: true,
            sortField: 'rutCliente',
            wrap: true,
            alling: 'left',
            export: true,
        }
    ]

    return { COLUMNS_RESULT };
}